import { createTranslationRef, createTranslationResource } from '@backstage/core-plugin-api/alpha';

export const projectPageTranslationRef = createTranslationRef({
  id: 'project-page',
  messages: {
    projectPage: {
      title: 'My Projects',
      subtitle: 'Project Explorer',
      pageTitleOverride: 'Projects',
      createButtonTitle: 'Register Existing Project',
      supportButtonTitle: 'All your Projects',
      searchPlaceholder: 'Filter',
      lifecycleFilterLabel: 'Lifecycle',
      typeFilterLabel: 'Type',
      selectAll: 'All',
    },
    projectForm: {
      title: 'Project Information',
      childProjects: 'Subprojects',
      childProjectsEmpty: 'No subproject was found associated with this project',
    },
    projectTableColumns: {
      number: 'Number',
      name: 'Name',
      title: 'Title',
      parent: 'Main Project',
      type: 'Project Type',
      lifecycle: 'Lifecycle',
      projectManager: 'Project Manager',
      priority: 'Priority',
      startDatePlanned: 'Start Date Planned',
      endDatePlanned: 'End Date Planned',
      startDateReal: 'Start Date Real',
      endDateReal: 'End Date Real',
      status: 'Status',
      percentCompleted: '% Completed',
      owner: 'Owner',
      executionType: 'Execution Type',
      applications: 'Applications',
    },
    projectApplications: {
      title: 'Applications associated with the project',
      emptyApplications: 'No application was found associated with this project',
      moreDetails: 'More Details',
      createApplication: 'Create Application in CMDB',
    }
  },
});

export const projectPageTranslations = createTranslationResource({
  ref: projectPageTranslationRef,
  translations: {
    en: () => import('./project-page-en'),
    es: () => import('./project-page-es'),
  },
});